import authService from "../services/AuthService";
import { logout } from "../stores/AuthSlice";
import { disconnectStomp } from "./stompClient";
import { queryClient } from "./QueryClient";
import type { AppDispatch } from "../stores/Store";

// Logout tập trung: gọi Keycloak/BE logout, ngắt WebSocket, xoá cache React Query
// (tránh rò dữ liệu user trước trên máy dùng chung) rồi clear Redux auth.
export const performLogout = async (dispatch: AppDispatch): Promise<void> => {
  try {
    await authService.logout();
  } finally {
    disconnectStomp();
    queryClient.clear();
    dispatch(logout());
  }
};
